import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import prasithi from "../../assets/documents/प्रसिध्दीपत्रक_0001.pdf";
import notice from "../../assets/documents/Notice.pdf";
import notice1 from "../../assets/documents/Notice for Expression of Interest for Hiring an Agency for Production of Documentary on Geoglyp.pdf";
import notice2 from "../../assets/documents/MahaSTRIDE PIU – Contractual Recruitment Advertisement.pdf";
import notice3 from "../../assets/documents/Hiring an Agency for Production of Documentary on Geoglyphs.pdf";
import notice4 from "../../assets/documents/E-Tender Nos. 1 to 8 (Conservation and Restoration).pdf";
import notice5 from "../../assets/documents/Documentary in Sign Language for Heritage Sites.pdf";
import notice6 from "../../assets/documents/Press Release.pdf";
import notice7 from "../../assets/documents/MITRA Advertisement Post Results 1.pdf";

export default function PressReleaseTicker() {
  const selectedLang = useSelector((state) => state.language.selectedLang);
 const pressReleases = [
   {
    titleMarathi: "• कातळशिल्पांवर माहितीपट निर्मितीसाठी एजन्सी नियुक्त करण्याबाबत",
    titleEnglish:
      "• Hiring an Agency for Production of Documentary on Geoglyphs",
    pdf: notice3,
  },
  {
    titleMarathi:
      "• ई-निविदा क्रमांक १ ते ८ (जतन व संवर्धन)",
    titleEnglish:
      "• E-Tender Nos. 1 to 8 (Conservation and Restoration)",
    pdf: notice4,
  },
  {
    titleMarathi:
      "• वर्ल्ड हेरिटेज डेस्क अंतर्गत डेटा एन्ट्री ऑपरेटर पदाची भरती रद्द - प्रसिद्धीपत्रक",
    titleEnglish:
      "• Cancellation of Recruitment for the Post of Data Entry Operator under World Heritage Desk - Press Release",
    pdf: prasithi,
  },
  {
    titleMarathi:
      "• पुरातत्व व वस्तुसंग्रहालये संचालनालया अंतर्गत राज्य संरक्षित स्मारके, वस्तुसंग्रहालये तथा ऐतिहासिक स्मारके यांच्या जतन व संवर्धनासाठी अनुभवी पुरवठादार संस्था/व्यक्ती यांच्या निवडेकरणेबाबत",
    titleEnglish:
      "• Regarding Selection of Experienced Supplier Agencies/Individuals for Conservation and Preservation of State Protected Monuments, Museums and Historical Monuments under the Directorate of Archaeology and Museums",
    pdf: notice,
  },
  
  {
    titleMarathi: "• वारसा स्थळांसाठी सांकेतिक भाषेतील माहितीपट",
    titleEnglish:
      "• Documentary in Sign Language for Heritage Sites",
    pdf: notice5,
  },
  {
    titleMarathi:
      "• कोकणातील कातळशिल्पांवर माहितीपट निर्मिती करण्यासाठी एजन्सी नियुक्त करण्याकरिता स्वारस्याची अभिव्यक्ती (EOI) मागविण्याबाबतची सूचना",
    titleEnglish:
      "• Notice for Expression of Interest for Hiring an Agency for Production of Documentary on Geoglyphs (Katalshilpa) of Konkan",
    pdf: notice1,
  },
  {
    titleMarathi:
      "• प्रसिद्धीपत्रक – वर्ल्ड हेरिटेज डेस्क (रत्नागिरी व मुंबई) येथील तात्पुरत्या पदांसाठीच्या निवड प्रक्रियेचा निकाल",
    titleEnglish:
      "• Press Release – Result of the Selection Process for Temporary Posts at World Heritage Desk (Ratnagiri and Mumbai)",
    pdf: notice6,
  },
  {
    titleMarathi: "• जाहिरात",
    titleEnglish: "• Advertisement",
    type: "page",
    link: "/advertisement",
  },
  {
    titleMarathi: "• महाSTRIDE PIU – कंत्राटी भरती जाहिरात",
    titleEnglish: "• MahaSTRIDE PIU – Contractual Recruitment Advertisement",
    pdf: notice2,
  },
  {
    titleMarathi: "• पद भरती 2023-24 (तपशील पाहा)",
    titleEnglish: "• Recruitment 2023-24 (View Details)",
    type: "page",
    link: "/recruitment",
  },  
   {
    titleMarathi: "• MITRA जाहिरात पोस्टचे निकाल",
    titleEnglish: "• MITRA Advertisement Post Results",
    pdf: notice7,
  },
];

  return (
    <div className="bg-[#c9902d] text-white overflow-hidden whitespace-nowrap py-3">
      <div className="animate-marquee flex w-max">

        {/* First Set */}
        <div className="flex shrink-0">
          {pressReleases.map((item, index) =>
            item.type === "page" ? (
              <Link
                key={`first-${index}`}
                to={item.link}
                className="font-semibold text-[#1e40af] hover:underline mr-16"
              >
                {selectedLang === "मराठी"
                  ? item.titleMarathi
                  : item.titleEnglish}
              </Link>
            ) : (
              <a
                key={`first-${index}`}
                href={item.pdf}
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-[#1e40af] hover:underline mr-16"
              >
                {selectedLang === "मराठी"
                  ? item.titleMarathi
                  : item.titleEnglish}
              </a>
            )
          )}
        </div>

        {/* Duplicate Set */}
        <div className="flex shrink-0">
          {pressReleases.map((item, index) =>
            item.type === "page" ? (
              <Link
                key={`second-${index}`}
                to={item.link}
                className="font-semibold text-[#1e40af] hover:underline mr-16"
              >
                {selectedLang === "मराठी"
                  ? item.titleMarathi
                  : item.titleEnglish}
              </Link>
            ) : (
              <a
                key={`second-${index}`}
                href={item.pdf}
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-[#1e40af] hover:underline mr-16"
              >
                {selectedLang === "मराठी"
                  ? item.titleMarathi
                  : item.titleEnglish}
              </a>
            )
          )}
        </div>

      </div>
    </div>
  );
}